import { reactive } from 'vue'
import { Store } from 'vuex'
import { Router } from 'vue-router'
import { State as StoreState } from '@/store/index'
import { ErrorMsgState, useErrorMsg } from '@/model/components/common/message/errorMessage'
import {
  NormalMsgState,
  useNormalMsg,
  convertData,
  clearNormalMsg,
} from '@/model/components/common/message/normalMessage'
import { userEntry } from '@/model/api/user/apiUserEntry'
import { useRouterUtil, RouterTypeData } from '@/model/router/router'
import { focusBlur } from '@/model/util/dom/domUtil'
import { UserEntryAuthState } from './userEntryAuthState'
import { checkFlowRedirect } from './userNoAuth'

/**
 * ログイン認証画面のDOM初期処理を実施する
 * @param state 状態
 * @param store vuex
 * @param router vue router
 */
const initDom = async (state: UserEntryAuthState, store: Store<StoreState>, router: Router) => {
  // 初期処理チェック(F5等でusernameが未設定の場合はTOP画面に遷移)
  await checkFlowRedirect(state.username, store, router)
}

/**
 * ワンタイムパスワード認証画面の初期状態を取得する
 * @param props propsデータ
 * @returns reactiveした初期状態
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const stateUserEntryAuth = (props: any): UserEntryAuthState => {
  const state = reactive<UserEntryAuthState>({
    loading: false,
    loadingReissue: false,
    username: props.username,
    password: '',
    type: props.type,
    dispPassword: false,
    redirect: props.redirect,
    downloadKey: props.downloadKey,
  })
  return state
}

/**
 * ワンタイムパスワードを認証して画面遷移を実施する
 * @param state 画面状態
 * @param store vuex
 * @param router vueRouter
 * @param error エラーメッセージ状態
 * @param normal 正常メッセージ状態
 */
const userEntryAuth = async (
  state: UserEntryAuthState,
  store: Store<StoreState>,
  router: Router,
  error: ErrorMsgState,
  normal: NormalMsgState
) => {
  // 一旦メッセージを全て初期化
  error.data.splice(0)
  normal.data.splice(0)
  // モバイルのためにfocusを外す
  focusBlur()
  // ローディングをONにする
  state.loading = true
  // api送信を実施
  const result = await userEntry(store).authenticate(state, error)
  // ローディングをOFFにする
  state.loading = false
  if (result.result) {
    // 正常時の場合は画面遷移を実施する
    const data: RouterTypeData.EntryData = {
      username: state.username,
      onetimepassword: state.password,
      type: state.type,
      redirect: state.redirect,
      downloadKey: state.downloadKey,
    }
    useRouterUtil(router).entry(data)
  }
}

/**
 * ワンタイムパスワードを発行する
 * @param state 画面状態
 * @param store vuex
 * @param error エラーメッセージ状態
 * @param normal 正常メッセージ状態
 */
const userEntryAuthSend = async (
  state: UserEntryAuthState,
  store: Store<StoreState>,
  error: ErrorMsgState,
  normal: NormalMsgState
) => {
  // 一旦メッセージを全て初期化
  normal.data.splice(0)
  error.data.splice(0)
  // ローディングをONにする
  state.loadingReissue = true
  // api送信を実施
  const result = await userEntry(store).send(state, error)
  // ローディングをOFFにする
  state.loadingReissue = false
  if (result.result) {
    // 正常時の場合は正常メッセージを表示する
    convertData('body.entry.redo.success', normal)
  }
}

export { initDom, stateUserEntryAuth, userEntryAuth, userEntryAuthSend, useErrorMsg, useNormalMsg, clearNormalMsg }
